/**
 * 会员编号：只来自 /api/member/getUserInfo、login、register 的 member_code。
 * 勿与自增 id、选妃列表 id 混用；保留前导 0（必须当字符串用）。
 */

export function formatMemberCode(value) {
  if (value == null || value === "") {
    return "";
  }
  // 保持接口原样字符串，避免 Number() 丢掉前导 0
  const text = String(value).trim();
  if (!text) {
    return "";
  }
  // 只接受纯数字编号（含前导 0 的 8 位）
  return /^\d+$/.test(text) ? text : "";
}

export function pickMemberCode(...sources) {
  for (let i = 0; i < sources.length; i += 1) {
    const src = sources[i];
    if (!src || typeof src !== "object") {
      continue;
    }
    const code = formatMemberCode(src.member_code);
    if (code) {
      return code;
    }
  }
  return "";
}
